/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import {
  getGiveawaysTabs,
  getGamesByGiveaways,
} from "../../../../features/cms/cmsSlice";
import FormTitle from "../../../FormTitle/FormTitle";
import styles from "./ByGiveaway.module.scss";
import CustomTabs from "../../components/CustomTabs/idnex";
import { GameItemList } from "../../components/GameItemList/GameItemList";

const ByGiveaway = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const giveawayTabs = useSelector(getGiveawaysTabs);
  const AllgamesWithgiveaway = useSelector(getGamesByGiveaways);
  const [tabs, setTabs] = useState();

  useEffect(() => {
    if (!type) history.push("/");
    if (!tabs) {
      const _tabs = giveawayTabs.map((t) => {
        return { ...t, comp: <GameItemList games={t.games} /> };
      });
      setTabs(_tabs);
    }
  }, [giveawayTabs, history, type, tabs, AllgamesWithgiveaway]);

  return (
    <div className={styles.body}>
      <FormTitle title="Select Giveaway or Promotion" />
      <div className={styles.wrapper}>
        {tabs && (
          <CustomTabs
            tabs={tabs}
            activeTab={history.location.state?.data}
            trackingTitle="Games By Giveaway/Promotion"
          />
        )}
      </div>
      <FormController
        backTo="/ticket-single-group/by-giveaway-landing"
        startOver="/"
        showBack
        showStartOver
        
      />
    </div>
  );
};

export default ByGiveaway;
